"use strict";
exports.__esModule = true;
exports.CODE_ORDER = exports.canDropOnto = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var ChargeSessionCodeType = ui_common_1.commonEnums.ChargeSessionCodeType;
var CODE_ORDER = new Map([
    [ChargeSessionCodeType.PROCEDURE.toUpperCase(), 0],
    [ChargeSessionCodeType.MODIFIER.toUpperCase(), 1],
    [ChargeSessionCodeType.DIAGNOSIS.toUpperCase(), 2]
]);
exports.CODE_ORDER = CODE_ORDER;
var getDroppableConfig = function (dropCandidate, dropTarget, position, allItems) {
    // check to see if they're the next in line.
    var candidateOrder = CODE_ORDER.get(dropCandidate.codeType.toUpperCase());
    var targetOrder = CODE_ORDER.get(dropTarget.codeType.toUpperCase());
    var targetDifference = Math.abs(candidateOrder - targetOrder);
    var permissibleDifference = 1;
    if (targetDifference > 1) {
        var hasMods = allItems.some(function (item) { return item.data.codeType === ChargeSessionCodeType.MODIFIER; });
        if (!hasMods) {
            permissibleDifference++;
        }
    }
    var rightAfter = position === 'after' &&
        candidateOrder === targetOrder + permissibleDifference;
    var rightBefore = position === 'before' &&
        candidateOrder === targetOrder - permissibleDifference;
    return { rightAfter: rightAfter, rightBefore: rightBefore };
};
var canDropOnto = function (dropCandidate, dropTarget, position, allItems) {
    // test to see if it's a search result
    if (ui_common_1.cmxTypeguards.isSearchResult(dropCandidate)) {
        // if they're of the same code type, then can drop
        // NOTE codeType and provenance are being tested here
        // search results and codes don't respect the same
        // definitions, so we have to compare two separate props
        var sameType = dropCandidate.codeType === dropTarget.provenance;
        if (sameType) {
            return true;
        }
    }
    else {
        // not supporting moving between lists yet.
        var inList = allItems.find(function (item) { return item.data.code === dropCandidate.code; });
        if (!inList) {
            return false;
        }
        // if they're of the same code type, then can drop
        // dropping on self is prevented in the accordion
        var sameCodeType = dropCandidate.codeType === dropTarget.codeType;
        if (sameCodeType) {
            return true;
        }
    }
    // for search results and reordering
    var _a = getDroppableConfig(dropCandidate, dropTarget, position, allItems), rightAfter = _a.rightAfter, rightBefore = _a.rightBefore;
    var targets = allItems
        .map(function (item) { return item.data; })
        .filter(function (item) { return item.codeType === dropTarget.codeType; });
    if (rightAfter) {
        return (targets.findIndex(function (item) { return item.code === dropTarget.code; }) ===
            targets.length - 1);
    }
    else if (rightBefore) {
        return targets[0].code === dropTarget.code;
    }
    else {
        return false;
    }
};
exports.canDropOnto = canDropOnto;
//# sourceMappingURL=can-drop.js.map